// @core/api/endpoints/product/list_product_categories.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductCategoriesResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List product categories
 * Returns all product categories for the marketplace catalog. Supports hierarchical tree structure.
 * @public This endpoint does not require authentication
 */
export async function ListProductCategories(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductCategoriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products/categories`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductCategoriesResponse>(requestPath, { ...requestOptions, params });
}
